var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnboardingBackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.4445,
    cy: 21.5285,
    r: 21.4953,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5938 22.5293C31.146 22.5293 31.5938 22.0816 31.5938 21.5293C31.5938 20.977 31.146 20.5293 30.5938 20.5293V22.5293ZM13.5883 20.8222C13.1978 21.2127 13.1978 21.8459 13.5883 22.2364L19.9523 28.6004C20.3428 28.9909 20.976 28.9909 21.3665 28.6004C21.757 28.2098 21.757 27.5767 21.3665 27.1862L15.7096 21.5293L21.3665 15.8724C21.757 15.4819 21.757 14.8488 21.3665 14.4582C20.976 14.0677 20.3428 14.0677 19.9523 14.4582L13.5883 20.8222ZM30.5938 20.5293L14.2954 20.5293V22.5293L30.5938 22.5293V20.5293Z",
    fill: "#55BAF8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingBackIcon);
export default __webpack_public_path__ + "static/media/onboarding_back_icon.c334a3600502cec763736a48ff4a1012.svg";
export { ForwardRef as ReactComponent };